import { Component, inject, ViewChild } from '@angular/core';
import {Router, RouterOutlet } from '@angular/router';
import { CommonsModule } from './presentation/common/commons.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FontAwesomeModule , FaIconLibrary} from '@fortawesome/angular-fontawesome';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { DataModule } from './data/data.module';
import { CountdownModule } from 'ngx-countdown';
import { AngularDeviceInformationService } from 'angular-device-information';
import { LoadingComponent } from './presentation/common/loading/loading.component';
import { AlertService } from './data/helpers/alert.service';
  
@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, CommonsModule, CountdownModule, DataModule, FormsModule, ReactiveFormsModule, FontAwesomeModule],
  providers:[AngularDeviceInformationService],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  router = inject(Router);
  @ViewChild(LoadingComponent)
  loader!: LoadingComponent

  constructor(library: FaIconLibrary, private alert: AlertService) {
    library.addIconPacks(fas);
  }
  
  ngAfterViewInit() {
    this.alert.register(this.loader);
  }
}
